// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'recurring-invoice.term': 'Due on receipt | {count} days',

    'recurring-invoice.frequency-once': 'Once',
    'recurring-invoice.frequency-weekly': 'Weekly',
    'recurring-invoice.frequency-monthly': 'Monthly',
    'recurring-invoice.frequency-monthly-specific-day': 'Monthly with set day',
    'recurring-invoice.frequency-yearly': 'Yearly',

    'recurring-invoice.page.title': 'Recurring Invoices',
    'recurring-invoice.page.search_results': 'Search Results',
    'recurring-invoice.page.create.title': 'New Recurring Invoice',
    'recurring-invoice.page.search.title': 'Find Recurring Invoices',
    'recurring-invoice.page.edit.title': 'Edit Recurring Invoice',
    'recurring-invoice.page.edit.email': 'Email Recurring Invoice',
    'recurring-invoice.page.all': 'All',

    'recurring-invoice.button.cancel': 'Cancel',
    'recurring-invoice.button.select': 'Select',
    'recurring-invoice.button.find': 'Find Recurring Invoices',
    'recurring-invoice.button.search': 'Apply',
    'recurring-invoice.button.create': 'Publish',
    'recurring-invoice.button.draft': 'Save as Draft',
    'recurring-invoice.button.print': 'Print',
    'recurring-invoice.button.email': 'Email',
    'recurring-invoice.button.send_email': 'Send Email',
    'recurring-invoice.button.move_warehouse_continue': 'Confirm move',

    'recurring-invoice.modal.title.move_warehouse': "Move this schedule's warehouse?",

    'recurring-invoice.error.message.update_not_allowed': "This schedule has been voided and can't be saved.",
    'recurring-invoice.button.new': 'New Recurring Invoice',
    'recurring-invoice.button.cancel_invoice': 'Void',
    'recurring-invoice.button.save': 'Save Changes',
    'recurring-invoice.button.delete': 'Permanently Delete',
    'recurring-invoice.button.edit': 'Edit',
    'recurring-invoice.button.restore': 'Restore',
    'recurring-invoice.button.reset': 'Reset',
    'recurring-invoice.button.record_payment': 'Record Payment',

    'recurring-invoice.placeholder.search': 'Search recurring invoices',

    'recurring-invoice.link.create_first_invoice': 'Click here to create your first recurring invoice',
    'recurring-invoice.link.recurring-invoices': ' Return to Recurring Invoices',
    'recurring-invoice.link.retry': 'Click here to retry',

    'recurring-invoice.checkbox.all': 'Check All',
    'recurring-invoice.checkbox.actions_label': 'with selected',

    'recurring-invoice.label.start_date': 'Start Date',
    'recurring-invoice.label.end_date': 'End Date',
    'recurring-invoice.label.next_run_date': 'Next Run Date',
    'recurring-invoice.label.due': 'Due',
    'recurring-invoice.label.day': 'Recurrence Day',
    'recurring-invoice.label.item': 'Item',
    'recurring-invoice.label.description': 'Description',
    'recurring-invoice.label.unit_cost': 'Unit Cost',
    'recurring-invoice.label.quantity': 'Quantity',
    'recurring-invoice.label.total': 'Total',
    'recurring-invoice.label.tax_total': 'Tax Total',
    'recurring-invoice.label.grand_total': 'Grand Total',
    'recurring-invoice.label.sub_total': 'Subtotal',
    'recurring-invoice.label.discount': 'Discount',
    'recurring-invoice.label.bill_to': 'Bill To',
    'recurring-invoice.label.balance': 'Balance',
    'recurring-invoice.label.subject': 'Subject',
    'recurring-invoice.label.to': 'To',
    'recurring-invoice.label.message': 'Message',

    'recurring-invoice.label.recurring_invoice_number': 'Recurring Invoice No',

    'recurring-invoice.label.title': 'Title',

    'recurring-invoice.label.from__transaction_date': 'From transaction date',
    'recurring-invoice.label.to__transaction_date': 'To transaction date',
    'recurring-invoice.label.transaction_date': 'Recurring Invoice Date',

    'recurring-invoice.label.from__printed_at': 'From printed at',
    'recurring-invoice.label.to__printed_at': 'To printed at',
    'recurring-invoice.label.printed_at': 'Printed At',

    'recurring-invoice.label.from__opened_at': 'From opened at',
    'recurring-invoice.label.to__opened_at': 'To opened at',
    'recurring-invoice.label.opened_at': 'Opened At',

    'recurring-invoice.label.from__paid_at': 'From paid at',
    'recurring-invoice.label.to__paid_at': 'To paid at',
    'recurring-invoice.label.paid_at': 'Paid At',

    'recurring-invoice.label.from__due_at': 'From due at',
    'recurring-invoice.label.to__due_at': 'To due at',
    'recurring-invoice.label.due_at': 'Due Date',

    'recurring-invoice.label.bill_to_entity_name': 'Bill To Customer',

    'recurring-invoice.label.bill_to_contact_name': 'Bill To Contact',

    'recurring-invoice.label.bill_to_address_line_1': 'Bill To Address Line 1',

    'recurring-invoice.label.bill_to_address_line_2': 'Bill To Address Line 2',

    'recurring-invoice.label.bill_to_province': 'Bill To Province',

    'recurring-invoice.label.bill_to_postal_code': 'Bill To Postal Code',

    'recurring-invoice.label.bill_to_country_name': 'Bill To Country',

    'recurring-invoice.label.ship_to_entity_name': 'Ship To Entity',

    'recurring-invoice.label.ship_to_contact_entity_name': 'Ship To Contact',

    'recurring-invoice.label.ship_to_contact_name': 'Ship To Contact',

    'recurring-invoice.label.ship_to_address_line_1': 'Ship To Address Line 1',

    'recurring-invoice.label.ship_to_address_line_2': 'Ship To Address Line 2',

    'recurring-invoice.label.ship_to_province': 'Ship To Province',

    'recurring-invoice.label.ship_to_postal_code': 'Ship To Postal Code',

    'recurring-invoice.label.ship_to_country_name': 'Ship To Country',

    'recurring-invoice.label.purchase_order_number': 'Purchase Order #',

    'recurring-invoice.label.term': 'Term',

    'recurring-invoice.label.frequency': 'Frequency',

    'recurring-invoice.label.invoice_action': 'After Creation',
    'recurring-invoice.label.save_as_draft': 'Save as Draft',
    'recurring-invoice.label.create_as_new_invoice': 'Save as New Invoice',
    'recurring-invoice.label.create_and_email_invoice': 'Email Invoice',

    'recurring-invoice.label.currency_name': 'Currency',
    'recurring-invoice.label.currency_sub_total_in_cents': 'Subtotal',
    'recurring-invoice.label.currency_discount_total_in_cents': 'Discount Total',
    'recurring-invoice.label.currency_tax_total_in_cents': 'Tax Total',
    'recurring-invoice.label.currency_grand_total_in_cents': 'Grand Total',
    'recurring-invoice.label.currency_balance_owing_in_cents': 'Balance Owing',
    'recurring-invoice.label.currency_shipping_total_in_cents': 'Shipping Total',

    'recurring-invoice.label.sold_by': 'Sales Person',

    'recurring-invoice.label.public_customer_message': 'Public Customer Message',

    'recurring-invoice.label.private_note': 'Private Note',
    'recurring-invoice.label.reference_number': 'Reference Number',

    'recurring-invoice.label.status': 'Status',

    'recurring-invoice.sort.field_label': 'Field',
    'recurring-invoice.sort.direction_label': 'Direction',
    'recurring-invoice.sort.direction_ascending': 'Ascending',
    'recurring-invoice.sort.direction_descending': 'Descending',

    'recurring-invoice.modal.title.recurring_invoice_cancel': 'Void Recurring Invoice',
    'recurring-invoice.modal.title.recurring_invoice_restore': 'Restore Recurring Invoice',

    'recurring-invoice.modal.message.recurring_invoice_cancel': 'Are you sure that you want to void this recurring invoice? This action cannot be undone. | Are you sure that you want to void these invoices? This action cannot be undone.',
    'recurring-invoice.modal.message.recurring_invoice_restore': 'Are you sure that you want to restore this recurring invoice? | Are you sure that you want to restore these invoices?',

    'recurring-invoice.success.message.recurring_invoice_created': 'Your recurring invoice has been created',
    'recurring-invoice.success.message.recurring_invoice_updated': 'Your recurring invoice has been updated',
    'recurring-invoice.success.message.recurring_invoice_cancelled': 'Your recurring invoice has been cancelled',
    'recurring-invoice.success.message.recurring_invoice_restored': 'Your recurring invoice has been restored | All selected invoices were restored',
    'recurring-invoice.success.message.recurring_invoice_deleted': 'Your recurring invoice has been permanently deleted | All selected invoices were permanently deleted',

    'recurring-invoice.error.message.recurring_invoice_deleted': 'This recurring invoice was already permanently deleted | These invoices were already permanently deleted',
    'recurring-invoice.error.message.recurring_invoice_restored': 'This recurring invoice was already restored | These invoices were already restored',
    'recurring-invoice.error.message.error_loading_page': 'Sorry, there was an error loading recurring-invoice.| Sorry, there was an error loading recurring-invoices.',
};
